export default __webpack_public_path__ + "static/media/icon-filter-close.c638410d.svg";